import { createPhotoModel } from 'models/PhotoModel';

export default createPhotoModel;
